module.exports = __webpack_public_path__ + "img/DK.80170fc2.svg";